import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

function NotLoggedInUsers() {
  const dispatch = useDispatch()
  const users = useSelector((store) => store.users.notLoggedInUsers)
  const [viewUsers, setViewUsers] = useState(false)

  return (
    <div>
      <button
        className='btn btn-info'
        onClick={() => setViewUsers((view) => !view)}
      >
        {!viewUsers ? 'View Users' : 'Hide Users'}
      </button>
      {viewUsers ? (
        <div className='d-flex flex-column mt-3'>
          {users && users.length ? (
            <div
              className='card shadow-sm p-3'
              style={{ borderRadius: '12px', background: '#f8f9fa' }}
            >
              <div className='mb-3 d-flex align-items-center'>
                <span
                  style={{
                    fontWeight: '600',
                    fontSize: '16px',
                    color: '#32325d',
                  }}
                >
                  Total Users: {users.length}
                </span>
              </div>
              <div className='table-responsive'>
                <table className='table table-hover mb-0'>
                  <thead className='thead-light'>
                    <tr>
                      <th
                        style={{
                          fontWeight: '600',
                          color: '#8898aa',
                          fontSize: '14px',
                        }}
                      >
                        User
                      </th>
                      <th
                        style={{
                          fontWeight: '600',
                          color: '#8898aa',
                          fontSize: '14px',
                        }}
                      >
                        Username
                      </th>
                      <th
                        style={{
                          fontWeight: '600',
                          color: '#8898aa',
                          fontSize: '14px',
                        }}
                      >
                        Email
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {users.map((user, idx) => {
                      let avatarUrl = null
                      let initials = ''
                      if (user.avatar) {
                        try {
                          avatarUrl = JSON.parse(user.avatar).url
                        } catch (e) {
                          avatarUrl = null
                        }
                      }
                      initials = `${user.first_name?.charAt(0) || ''}${
                        user.last_name?.charAt(0) || ''
                      }`
                      return (
                        <tr
                          key={user.id}
                          style={{
                            backgroundColor: idx % 2 === 0 ? '#fff' : '#f4f6fb',
                          }}
                        >
                          <td>
                            <div className='d-flex align-items-center'>
                              <div
                                className='avatar avatar-sm rounded-circle mr-3'
                                style={{
                                  backgroundColor: avatarUrl
                                    ? 'transparent'
                                    : '#5e72e4',
                                  minWidth: '36px',
                                  height: '36px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  overflow: 'hidden',
                                  position: 'relative',
                                }}
                              >
                                {avatarUrl ? (
                                  <img
                                    src={avatarUrl}
                                    alt={`${user.first_name} ${user.last_name}`}
                                    style={{
                                      width: '100%',
                                      height: '100%',
                                      objectFit: 'cover',
                                      borderRadius: '50%',
                                    }}
                                    onError={(e) => {
                                      e.target.style.display = 'none'
                                      if (e.target.nextSibling)
                                        e.target.nextSibling.style.display =
                                          'flex'
                                    }}
                                  />
                                ) : null}
                                <span
                                  className='text-white font-weight-bold'
                                  style={{
                                    fontSize: '14px',
                                    display: avatarUrl ? 'none' : 'block',
                                    position: 'absolute',
                                    left: 0,
                                    right: 0,
                                    top: 0,
                                    bottom: 0,
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    height: '100%',
                                    width: '100%',
                                    textAlign: 'center',
                                    lineHeight: '36px',
                                  }}
                                >
                                  {initials}
                                </span>
                              </div>
                              <div>
                                <span
                                  className='font-weight-600'
                                  style={{ fontSize: '15px', color: '#32325d' }}
                                >
                                  {user.first_name} {user.last_name}
                                </span>
                              </div>
                            </div>
                          </td>
                          <td style={{ fontSize: '14px', color: '#525f7f' }}>
                            {user.username}
                          </td>
                          <td style={{ fontSize: '14px', color: '#525f7f' }}>
                            {user.email}
                          </td>
                        </tr>
                      )
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          ) : (
            <div className='d-flex flex-column align-items-center justify-content-center p-4'>
              <FontAwesomeIcon
                icon={faTriangleExclamation}
                className='text-danger mb-2'
                style={{ fontSize: '32px' }}
              />
              <p
                className='mb-0'
                style={{ fontWeight: '500', color: '#525f7f' }}
              >
                No users found
              </p>
            </div>
          )}
        </div>
      ) : null}
    </div>
  )
}

export default NotLoggedInUsers
